// extracted by mini-css-extract-plugin
export var linkText = "_m3-0";